"use client"

import { useEffect, useSyncExternalStore } from "react"

const subscribe = (cb: () => void) => {
  window.addEventListener("online", cb)
  window.addEventListener("offline", cb)
  return () => {
    window.removeEventListener("online", cb)
    window.removeEventListener("offline", cb)
  }
}

const getSnapshot = () => navigator.onLine
const getServerSnapshot = () => true

export function OfflineBanner() {
  const online = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  useEffect(() => {
    document.documentElement.style.setProperty("--offline-banner-h", online ? "0px" : "24px")
  }, [online])

  return (
    <div className={`fixed top-0 inset-x-0 z-[60] bg-muted text-muted-foreground text-center text-xs px-m overflow-hidden transition-[height,opacity] duration-300 ease-in-out ${online ? "h-0 opacity-0" : "h-6 opacity-100 py-1"}`}>
      Похоже, нет интернета. Часть функций недоступна
    </div>
  )
}
